module.exports = __webpack_public_path__ + "img/image-04.67289b7c.jpeg";